import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class OrderPochtaCourierAddressWrite
*  Адрес назначения (индекс, город, улица и дом обязательны).
*/
export class OrderPochtaCourierAddressWrite extends ActiveModel {

/**
  * postalCode
  * Почтовый индекс.
  */
  @ActiveField('')
  postalCode: string = ''


/**
  * city
  * Город / населённый пункт.
  */
  @ActiveField('')
  city: string = ''


/**
  * street
  * Улица.
  */
  @ActiveField('')
  street: string = ''


/**
  * house
  * Дом/строение.
  */
  @ActiveField('')
  house: string = ''


/**
  * apartment
  * Квартира / офис; опционально.
  */
  @ActiveField()
  apartment?: string


/**
  * region
  * Регион (субъект РФ); опционально, например из PostofficeByIndex.
  */
  @ActiveField()
  region?: string
}
